/**
 * «Сегодня» сервера — число, по которому он считает срез «как знаем сейчас»
 * (`horizon` любого ответа без `as_of`). Часы вкладки для этого не годятся:
 * у сервера и у браузера разные часовые пояса и разные полночи.
 *
 * Читается лёгким ответом списка циклов; один запрос на всех, ответ помнится
 * несколько минут.
 */

import { api } from './client';

/** Сколько живёт запомненное «сегодня» сервера: полночь за сеанс всё равно наступит. */
const TTL_MS = 5 * 60 * 1000;

let known: { at: number; value: string } | null = null;
let pending: Promise<string | null> | null = null;

/** Запомненное «сегодня» сервера, если оно свежее; иначе `null`. */
export function knownServerToday(): string | null {
  return known && Date.now() - known.at < TTL_MS ? known.value : null;
}

/** «Сегодня» сервера; `null`, если сервер не ответил. */
export function serverToday(): Promise<string | null> {
  const fresh = knownServerToday();
  if (fresh) return Promise.resolve(fresh);
  if (!pending) {
    pending = api
      .seasonCycles({})
      .then((reply) => {
        known = { at: Date.now(), value: reply.horizon };
        return reply.horizon;
      })
      .catch(() => null)
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

/** Только для тестов: забыть запомненную дату. */
export function forgetServerToday(): void {
  known = null;
  pending = null;
}
